import { IFirstHandReport, IResortPathInfo } from 'api/resort/types';
import { fetchResortLastFHReport } from 'api/resort/static';
import { BoxWithShadow } from 'components/blocks/BoxWithShadow';
import { BlockHeader } from 'components/blocks/BlockHeader';
import { BlockContent } from 'components/blocks/BlockContent';
import classNames from 'classnames';
import { NextLinkTr } from 'components/blocks/NextLink';
import { useFakeQueryWithInitialValue } from 'util/useQueryWithInitialValue';
import { Routes } from 'routes';
import { Report } from 'components/resort/Report';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { BLUR_CONTENT_STYLE_NAME } from 'theme';
import styles from './styles.module.scss';

export const ResortLastHandReport = ({ resort, initial }:{ resort: IResortPathInfo, initial: IFirstHandReport | null }) => {
  const { t } = useOTSTranslation('common');
  const { hasFreshData, current } = useFakeQueryWithInitialValue(['resort-last-fh-report', resort.uuid],
    async () => fetchResortLastFHReport(resort.uuid), initial);
  // console.log(hasFreshData, current);
  if (current) {
    return (
      <BoxWithShadow>
        <BlockHeader useH3 title={t('resort.skiReport.firstHandReport')}>
          <NextLinkTr href={Routes.resortFHReports(resort)} scroll>
            {t('resort.skiReport.allFirstHandReports')}
          </NextLinkTr>
        </BlockHeader>
        <BlockContent className={classNames({ [BLUR_CONTENT_STYLE_NAME]: !hasFreshData })}>
          <Report report={current} className={styles.wrapper} />
        </BlockContent>
      </BoxWithShadow>
    );
  }
  return null;
};
